'use strict';

import modalRecuTemplate from "./formulario.modal.recuperar.html";
import modalRecuController from "./formulario.modal.recuperar.controller";


class CodigoRegArtModalController {
  constructor($uibModalInstance, data, Modal, Auth, DataService, $location, Storage, SidenavFactory, Message, $log, Sidenav) {
    'ngInject';

    this.items = data;
    this.usuario = data.usuario;
    this.correo = data.correo;
    this.$uibModalInstance = $uibModalInstance;
    this.$location = $location;
    this.Modal = Modal;
    this.Auth = Auth;
    this.DataService = DataService;
    this.SidenavFactory = SidenavFactory;
    this.Storage = Storage;
    this.Message = Message;
    this.$log = $log;
    this.Sidenav = Sidenav;

  }

  $onInit() {
    this.focus = true;
    this.$log.log('--->Modal pregunta', this.items);
    this.esRefrigerio = false;
    this.$log.log('es__Refrigerio');
    this.$log.log(this.Storage.get('esRefrigerio'));
    if (this.Storage.get('esRefrigerio')) {
      this.esRefrigerio = true;
    }

  }

  renovacion() {
    this.items.tipo = 'RENOVACION';
    this.DataService.post(`certificaciones`, this.items)
      .then(response => {
        if (response) {
          this.Storage.setSession('certificacion', response.certificacion.id_certificacion);
          this.Sidenav.path('registro');
          this.$uibModalInstance.dismiss('cancel');
        }
      });
  }

  nuevo() {
    if (this.esRefrigerio) {      
      var data = {};
      data.fid_formulario = 10;

      this.DataService.get(`certificaciones/verificar/aguinaldo`)
          .then(response => {
            this.$log.log('verifica si tiene un formulario de aguinaldo vigente  APROBADO O APROBADO_ENVIADO');
            this.$log.log(response);
            if (response===true) {
              this.Modal.show({
                template: modalRecuTemplate,
                controller: modalRecuController,
                data: data,
                size: 'medium'
              });
              this.$uibModalInstance.dismiss('cancel');
            }
            else {
              this.items.tipo = 'REGISTRO';
              this.DataService.post(`certificaciones`, this.items)
                .then(response => {
                  if (response) {
                    this.Storage.setSession('certificacion', response.certificacion.id_certificacion);
                    this.Sidenav.path('registro');
                    this.$uibModalInstance.dismiss('cancel');
                  }
                });
            }
          });
       
       
    }else {
      this.items.tipo = 'REGISTRO';
      this.DataService.post(`certificaciones`, this.items)
        .then(response => {
          if (response) {
            this.$log.log(response);
            this.Storage.setSession('certificacion', response.certificacion.id_certificacion);
            this.Sidenav.path('registro');
            this.$uibModalInstance.dismiss('cancel');
          }
        });

    }

  }

  nuevo1() {
    this.items.tipo = 'REGISTRO';
    this.DataService.post(`certificaciones`, this.items)
      .then(response => {
        if (response) {
          this.Storage.setSession('certificacion', response.certificacion.id_certificacion);
          this.Sidenav.path('registro');
          this.$uibModalInstance.dismiss('cancel');
        }
      });
  }

  cancel() {
    this.focus = false;
    this.$uibModalInstance.dismiss('cancel');
  }

}

export default CodigoRegArtModalController;



// WEBPACK FOOTER //
// ./src/app/components/probolivia/empresario/formulario/formulario.emp.reg.modal.controller.js